// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export type TraduccionCmpGdprSinLogoP5Params = Record<"cookies_policy", string>;

export class TraduccionCmpGdprSinLogoP5 extends TraduccionLiteral<TraduccionCmpGdprSinLogoP5Params> {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.p_5";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoP5 {
        this.VALUES ??= this.completar({
            "valor": {
                "es": "Con su consentimiento, nosotros y <a href=\"javascript:void(0)\" class=\"link-vendors\">nuestros socios</a> usamos cookies o tecnologías similares para almacenar, acceder y procesar datos personales como su visita en este sitio web. Puede retirar su consentimiento u oponerse al procesamiento tratamiento de datos basado en intereses legítimos en cualquier momento haciendo clic en <a href=\"javascript:void(0)\" class=\"btn-gdpr-configure\">\"Configurar\"</a> o en nuestra <a href=\"javascript:void(0)\" class=\"cmp-w-link\" data-link=\"{{cookies_policy}}\">Política de Cookies</a> en este sitio web."
            },
            "defecto": "Con su consentimiento, nosotros y <a href=\"javascript:void(0)\" class=\"link-vendors\">nuestros socios</a> usamos cookies o tecnologías similares para almacenar, acceder y procesar datos personales como su visita en este sitio web. Puede retirar su consentimiento u oponerse al procesamiento tratamiento de datos basado en intereses legítimos en cualquier momento haciendo clic en <a href=\"javascript:void(0)\" class=\"btn-gdpr-configure\">\"Configurar\"</a> o en nuestra <a href=\"javascript:void(0)\" class=\"cmp-w-link\" data-link=\"{{cookies_policy}}\">Política de Cookies</a> en este sitio web."
        }, idiomas);

        return super.build(lang, this.VALUES, ["cookies_policy"]);
    }

    /* INSTANCE */
}
